<template lang="pug">
div
  el-collapse(accordion)
      el-collapse-item(:title="titulo" name="1")
        el-table(:data="atividades", style="width: 100%" :header-row-style="headerRowStyle" border)
          el-table-column(:formatter="formataTipo", label="tipo")
          el-table-column(:formatter="getArea", :label="getLabel()")
          el-table-column(v-if="tipoAtividade === 'OUTRAS_ATIVIDADES'" prop="observacoes", label="Observações")
</template>
<script>
import estadosBr from '@/constants/estados'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppCollapse from '@/components/AppCollapse'
const tipoOutrasAtividades = require('@/utils/tipoOutrasAtividades').default

export default {
  components: {
    AppResumoDocumentos,
    AppCollapse
  },
  props: {
    atividades: {
      Type: Object,
      required: true
    },
    titulo: {
      Type: String,
      required: true
    },
    tipoAtividade: {
      Type: String,
      required: true
    }
  },
  data () {
    return {
      estadosBr
    }
  },
  methods: {
    getArea (row) {
      switch (this.tipoAtividade) {
        case 'SEMOVENTES':
          return row.numeroCabecas
        case 'EDIFICACOES':
          return `${row.area.toString().replace('.', ',')} ${row.descUnidadeArea}`
        default:
          return `${row.area.toString().replace('.', ',')} hectare(s)`
      }
    },
    getLabel () {
      switch (this.tipoAtividade) {
        case 'SEMOVENTES':
          return 'Número de Cabeças'
        default:
          return 'Área'
      }
    },
    formataTipo (row) {
      if (this.tipoAtividade === 'OUTRAS_ATIVIDADES') {
        return this.formataDescOutrasAtividades(row)
      }
      return row.descricao ? `${row.descTipo} - ${row.descricao}` : row.descTipo
    },
    formataDescOutrasAtividades (row) {
      const tipoText = tipoOutrasAtividades.filter(item => item.codigo === row.tipo)[0].label
      return row.descricao ? `${tipoText} - ${row.descricao}` : tipoText
    },
    headerRowStyle () {
      return {
        backgroundColor: '#128d12c7',
        color: '#128d12c7'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
  color: #606266;
}

.text {
  color: #696580;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppCollapse.vue